import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminReviews from "@/pages/AdminReviews";
import { Toaster } from "@/components/ui/sonner";

function useRevealOnScroll() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function AppShell() {
  useRevealOnScroll();
  return (
    <div className="App">
      <LandingPage />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppShell />} />
        <Route
          path="/admin/reviews"
          element={
            <>
              <AdminReviews />
              <Toaster position="bottom-right" theme="dark" />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
